import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import './styles/index.css';
import './styles/Fonts.css';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
rootElement.classList.add('full');

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
